import React, { useState, useEffect } from 'react';
import RichTextEditor from 'react-rte';

const RichTextEditorWrapper = ({ value, setFieldValue, fieldName, handleBlur, placeholder = "Write your page description here..." }) => {
  const [editorValue, setEditorValue] = useState(
    RichTextEditor.createValueFromString(value || '', 'html')
  );

  // ✅ Only re-sync if value changes *on mount* or *on reinitialize*
  useEffect(() => {
    setEditorValue(RichTextEditor.createValueFromString(value || '', 'html'));
  }, []); // <<=== Only on mount

  const handleEditorChange = (newValue) => {
    setEditorValue(newValue);
    setFieldValue(fieldName, newValue.toString('html'));
  };

  return (
    <RichTextEditor
      value={editorValue}
      onChange={handleEditorChange}
      onBlur={handleBlur}
      editorClassName="custom-rte-editor"
      editorProps={{ placeholder }}
    />
  );
};

export default RichTextEditorWrapper;
